import i18next from 'i18next';
import React from 'react';
import { useQuery } from 'react-query';
import { useLoaderData } from 'react-router-dom';
import { Loader } from '../../components/loader/Loader';
import { MainApp } from '../../components/mainApp/MainApp';
import { getCategories } from '../../queries/categoriesQuery';
import { getMarkers } from '../../queries/markersQuery';

export const SingleCategory: React.FC = () => {
  const categoryId = useLoaderData() as string;
  const categories = useQuery('categories', getCategories);
  const markers = useQuery('markers', getMarkers);
  const isDataLoading = categories.isLoading || markers.isLoading;
  const currentCategory = categories.data?.find(category => category.id === categoryId);

  if (isDataLoading) {
    return <Loader />;
  }

  if (!currentCategory) {
    throw new Error(i18next.t('noMarkersFound'));
  }

  return (
    <MainApp
      categories={categories.data}
      markers={markers.data}
      currentCategory={currentCategory}
    />
  );
};
